var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_common_box"},[(!_vm.fromListing)?_c('login-header',{attrs:{"isAlibabaSite":_vm.isAlibabaSiteTalg}}):_vm._e(),_c('router-view'),_c('login-footer',{attrs:{"isAlibabaSite":_vm.isAlibabaSiteTalg}}),_c('fixedRightNav',{attrs:{"source":"login"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }